<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    id="service-history-datatable"
    ref="datatable"
    title="Service History"
    :source="source"
    :config="config"
    :filters="filters"
    :map-records="ajaxConfig"
    subpage
    :flat="flat"
    no-download
    :min-height="400"
    @draw-complete="$emit('draw-complete', $event)"
  />
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { getPathValueAt } from "@/lib/url.js";

import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    customerId: {
      type: Number,
      default: null
    },
    address: {
      type: Object,
      default: null
    }
  },
  emits: ["draw-complete"],
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    ...mapGetters(["jobStatusEnabled"]),
    config() {
      return {
        order: [[1, "desc"]],
        columns: [
          { data: "appointment" },
          {
            data: "when",
            title: "Scheduled For",
            filterName: "scheduled_time"
          },
          { data: "status", title: "Appt Status", searchable: false },
          { data: "job" },
          {
            data: "job_status",
            title: "Job Status",
            filterName: "job_status_id",
            orderable: false,
            visible: this.jobStatusEnabled
          },
          { data: "permit", orderable: false, searchable: false },
          {
            data: "technician",
            title: "Technician(s)",
            filterName: "technician_id"
          },
          {
            data: "task_type",
            title: "Service Category",
            filterName: "service_category"
          },
          {
            data: "location_name",
            title: "Location Name",
            visible: !this.address
          },
          {
            visible: !this.address,
            data: "address",
            orderable: false,
            filterName: "address_id"
          },
          { data: "total", orderable: false, searchable: false },
          { data: "balance", orderable: false, searchable: false }
        ]
      };
    }
  },
  methods: {
    ajaxConfig(config) {
      const customerId = this.customerId || getPathValueAt(1);
      config.customer_id = customerId;
      return config;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(table.table tr td.job-balance-cell) {
  color: var(--danger-color) !important;
}

:deep(table.table tr td) {
  white-space: nowrap;
}

:deep(table.table tr td.breakable-cell) {
  white-space: normal;
}
</style>
